import { useTranslation } from "react-i18next";

/** Returns a picker: English by default, French when the visitor chose French. */
export const useL = () => {
  const { i18n } = useTranslation();
  const fr = (i18n.language || "en").startsWith("fr");
  return (en: string, frText: string) => (fr ? frText : en);
};
